<template>
  <b-modal id="save-popup-modal" centered>
    <p class="modal-message">
      Save this file? If you don't save, your changes will be lost.
    </p>
    <div slot="modal-footer">
      <b-btn
        variant="secondary"
        class="mr-1 border-secondary bg-white text-secondary"
        @click="saveWithRedirect(false)"
        :disabled="isLoading"
      >
        Save & Edit
      </b-btn>
      <b-btn
        variant="primary"
        class="ml-1"
        @click="saveWithRedirect(true)"
        :disabled="isLoading"
      >
        Save & Exit
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "SavePopupModal",
  props: ["publishPopup"],
  methods: {
    ...mapMutations("designs", ["setActiveListType"]),
    async saveWithRedirect(withRedirect) {
      this.$root.$emit("bv::hide::modal", "save-popup-modal");

      if (await this.publishPopup() && withRedirect) {
        this.$router.push({ name: "engagementNewsPopUp" });
        this.setActiveListType("saved");
      }
    },
  },
  computed: {
    ...mapState("engagementPopup", ["isLoading"]),
  },
};
</script>

<style>
</style>